export default "__VITE_ASSET__Jb93IR$N__"